// extracted by mini-css-extract-plugin
module.exports = {"wrapper-Default":"style_wrapper-Default__R73v_","wrapper-Small":"style_wrapper-Small__Ts0bs"};